module.exports = __webpack_public_path__ + "media/assets/speed-02777a9f81a5207e82770c0e80ff6e6f.png";